// Placeholder component - FloatingShapes was removed during rebuild
const FloatingShapes = ({ variant, density }: { variant?: string; density?: string }) => null;
export default FloatingShapes;
